<script setup>
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  rule: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete', 'toggleActive']);

const isActive = computed({
  get: () => props.rule.active,
  set: () => emit('toggleActive', props.rule),
});

const TYPE_LABELS = {
  info: 'Info',
  menu: 'Menú',
  intake: 'Intake',
  journey: 'Journey',
  age_restriction: 'Edad',
};

const TYPE_COLORS = {
  info: 'bg-n-blue-3 text-n-blue-11',
  menu: 'bg-n-teal-3 text-n-teal-11',
  intake: 'bg-n-amber-3 text-n-amber-11',
  journey: 'bg-n-violet-3 text-n-violet-11',
  age_restriction: 'bg-n-ruby-3 text-n-ruby-11',
};

const typeLabel = TYPE_LABELS[props.rule.type] || props.rule.type;
const typeColor =
  TYPE_COLORS[props.rule.type] || 'bg-n-slate-3 text-n-slate-11';
</script>

<template>
  <div
    class="flex items-center gap-3 px-4 py-3 rounded-xl border border-n-weak bg-n-background hover:bg-n-slate-2 transition-colors"
  >
    <span
      class="shrink-0 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
      :class="typeColor"
    >
      {{ typeLabel }}
    </span>

    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium text-n-slate-12 truncate">
        {{ rule.title }}
      </p>
    </div>

    <div class="flex items-center gap-2 shrink-0">
      <Switch
        v-model="isActive"
        :title="
          rule.active
            ? $t('INTEGRATION_SETTINGS.RAS.RULE_CARD.DEACTIVATE')
            : $t('INTEGRATION_SETTINGS.RAS.RULE_CARD.ACTIVATE')
        "
      />

      <Button
        icon="i-lucide-pen"
        slate
        xs
        ghost
        :title="$t('INTEGRATION_SETTINGS.RAS.RULE_CARD.EDIT')"
        @click="emit('edit', rule)"
      />
      <Button
        icon="i-lucide-trash"
        slate
        xs
        ghost
        :title="$t('INTEGRATION_SETTINGS.RAS.RULE_CARD.DELETE')"
        @click="emit('delete', rule)"
      />
    </div>
  </div>
</template>
